function Footer() {
	return (
		<div className="w-full footer text-center py-2 mb-2 mt-4 bg-primary text-white">
			Created by <a href="https://twitter.com/@mager19">@mager19</a> -
			Info: https://restcountries.com/
		</div>
	);
}

export default Footer;
